import { Paginacao } from "@/types/paginacao";
import { LicitacaoVencedorLote } from "../licitacao-vencedor-lote";
import { ItemLicitacao } from "../item-licitacao";

export class RetornoBuscarVencedores extends Paginacao {
  DtAdjudicacao: Date;
  DtHomologacao: Date;
  FlHomologParcial: string;
  licitacaoVlTotalLicitado: number;
  vencedores: LicitacaoVencedorLote[];

  montarObjeto(data: any): void {
    if (data.DtAdjudicacao) this.DtAdjudicacao = new Date(data.DtAdjudicacao);
    if (data.DtHomologacao) this.DtHomologacao = new Date(data.DtHomologacao);
    if (data.FlHomologParcial)
      this.FlHomologParcial = data.FlHomologParcial === "S" ? "Sim" : "Não";
    this.licitacaoVlTotalLicitado = data.licitacaoVlTotalLicitado;
    this.page = data.page;
    this.pageSize = data.pageSize;
    this.totalRows = data.totalRows;
    this.vencedores = data.vencedores.map((v) => {
      const vencedor = Object.assign(new LicitacaoVencedorLote(), v);
      vencedor.tratarDadosDaAPI();
      vencedor.ItemLoteLicitacao = v.ItemLoteLicitacao.map((ill) => {
        const item = Object.assign(new ItemLicitacao(), ill);
        return item;
      });
      return vencedor;
    });
  }
}
